var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-container"},[_c('p',{staticClass:"title"},[_vm._v("当前积分")]),_c('h3',{staticClass:"score"},[_vm._v(" "+_vm._s(_vm.score)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }